import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card } from '../../components/ui/card';
import { Switch } from '../../components/ui/switch';
import { Label } from '../../components/ui/label';
import SettingsLayout from '../../components/SettingsLayout';
import { useWorkspace } from '../../contexts/WorkspaceContext';
import { API_URL } from '../../lib/apiBase';

const PrivacyRow = ({ title, description, value, onChange, testId }) => (
  <div className="flex items-start justify-between gap-4 py-4" data-testid={testId}>
    <div className="min-w-0">
      <Label className="text-sm font-medium block mb-1">{title}</Label>
      <p className="text-xs text-muted-foreground">{description}</p>
    </div>
    <Switch checked={!!value} onCheckedChange={onChange} data-testid={`${testId}-switch`} />
  </div>
);

const PrivacyPage = () => {
  const { currentWorkspace, refreshUsage } = useWorkspace();
  const [publicRoadmap, setPublicRoadmap] = useState(false);
  const [publicChangelog, setPublicChangelog] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!currentWorkspace) return;
    setPublicRoadmap(!!currentWorkspace.public_roadmap);
    setPublicChangelog(!!currentWorkspace.public_changelog);
  }, [currentWorkspace]);

  const updateField = async (field, value) => {
    if (!currentWorkspace) return;
    setSaving(true);
    try {
      await axios.put(`${API_URL}/api/workspaces/${currentWorkspace.id}`, { [field]: value });
      toast.success('Privacy setting updated');
      if (typeof refreshUsage === 'function') refreshUsage();
    } catch (_e) {
      toast.error('Failed to update setting');
    } finally {
      setSaving(false);
    }
  };

  return (
    <SettingsLayout
      title="Privacy & Access"
      description="Control what's visible outside your workspace."
    >
      <Card className="px-6 py-2 divide-y" data-testid="privacy-card">
        <PrivacyRow
          title="Public Roadmap"
          description="Anyone with the link can see your public roadmap page. Great for building in public."
          value={publicRoadmap}
          onChange={(v) => { setPublicRoadmap(v); updateField('public_roadmap', v); }}
          testId="privacy-public-roadmap"
        />
        <PrivacyRow
          title="Public Changelog"
          description="Publish your changelog at a shareable URL. Includes RSS feed for followers."
          value={publicChangelog}
          onChange={(v) => { setPublicChangelog(v); updateField('public_changelog', v); }}
          testId="privacy-public-changelog"
        />
      </Card>

      <p className="text-xs text-muted-foreground mt-4">
        More privacy controls (guest submissions, moderation, masked identities) unlock with Basic plan.
      </p>
    </SettingsLayout>
  );
};

export default PrivacyPage;
